import * as Types from 'src/actions/investor-type/get/Types';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'src/reducers/RootReducer';
import { ActionCreator, Dispatch } from 'react-redux';
import ApiClient from 'src/services/api-client/ApiClient';
import { AxiosResponse } from 'axios';
import InvestorType from 'src/entities/InvestorType';
import ValidatorService from 'src/services/validation/Validation.service';
import EnumTypes from 'src/services/EnumStates/EnumTypes';

export interface GetInvestorTypeAttempt extends Action {
  type: Types.GET_INVESTOR_TYPE_ATTEMPT;
}

export interface GetInvestorTypeSuccess extends Action {
  type: Types.GET_INVESTOR_TYPE_SUCCESS;
  payload: InvestorType;
}

export interface GetInvestorTypeFailure extends Action {
  type: Types.GET_INVESTOR_TYPE_FAILURE;
  payload: {};
}

export type GetInvestorTypeAction = GetInvestorTypeAttempt |
  GetInvestorTypeSuccess | GetInvestorTypeFailure;

export interface GetInvestorTypeThunk extends ThunkAction<Promise<GetInvestorTypeAction>,
  RootState, null> { }

export const getInvestorTypeAttempt: ActionCreator<GetInvestorTypeAttempt> = () => (
  { type: Types.GET_INVESTOR_TYPE_ATTEMPT }
);

export const getInvestorTypeSuccess: ActionCreator<GetInvestorTypeSuccess> =
  (investorType: InvestorType) => (
    {
      type: Types.GET_INVESTOR_TYPE_SUCCESS,
      payload: investorType
    }
  );

export const getInvestorTypeFailure: ActionCreator<GetInvestorTypeFailure> = (error: {}) =>
  (
    {
      type: Types.GET_INVESTOR_TYPE_FAILURE,
      payload: error
    }
  );

export const getInvestorType: ActionCreator<GetInvestorTypeThunk> = (
  personId: number,  personType: string
): GetInvestorTypeThunk => {

  return (dispatch: Dispatch<RootState>): Promise<GetInvestorTypeAction> => {
    dispatch(getInvestorTypeAttempt());
    return ApiClient.investorType.get(personId, {personType: personType})
      .then((response: AxiosResponse<InvestorType>): GetInvestorTypeSuccess => {
        response.data.type = EnumTypes.getInvestorTypeName(response.data.type);
        const investorType: InvestorType = new InvestorType(response.data);

        return dispatch(getInvestorTypeSuccess(investorType));
      }).catch((e: { response: { data: { error: {} } } }): GetInvestorTypeFailure => {
        const errorMessages = ValidatorService
          .translateValidations(e && e.response && e.response.data && e.response.data.error);

        return dispatch(getInvestorTypeFailure(errorMessages));
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/investor-type/get/GetInvestorType.actions.tsx